// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class HelpPlanTypeVm {
    @AutoMap() htyId: string;
    @AutoMap() htyCode: string;
    @AutoMap() htyName: string;
    @AutoMap() helpPlans: any[];
}
